import Api from "./Api.service"
export default class CosaService {
    static SubirArchivos(formData) {
        return Api.post("archivo/subir", formData);
    }
    static ActualizarComisiones(semestre, comiIds) {
        return Api.get(`serviceApi/comisiones/${semestre}?comiIds=${comiIds}`);
    }
    
}